export default __webpack_public_path__ + "static/media/Group 174067.09adcea2.svg";